import { render, staticRenderFns } from "./RegConfirm.vue?vue&type=template&id=7c13e403&"
import script from "./RegConfirm.vue?vue&type=script&lang=js&"
export * from "./RegConfirm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports